import instance from "../../api/instance"
const path = '/wv/customer_replies'

export default {
  async update(id, feedback_reply) {
    let body = {feedback_reply}
    return instance().put(path + '/' + id, body)
  }
}
